import createReactComponent from '../createReactComponent';
var RefreshCw = createReactComponent('RefreshCw', [['path', {
  d: 'M21 2v6h-6',
  key: '1lwg0q'
}], ['path', {
  d: 'M3 12a9 9 0 0115-6.7L21 8',
  key: 'tgdjnq'
}], ['path', {
  d: 'M3 22v-6h6',
  key: '6llvyv'
}], ['path', {
  d: 'M21 12a9 9 0 01-15 6.7L3 16',
  key: '11j5ai'
}]]);
export default RefreshCw;